export const RISE_WITH_PRESENCE_WHATSAPP = '61488248572';

export function formatEnquiryMessage({ name, email, message }) {
  const lines = [
    'Hello Rise With Presence,',
    '',
    'I would like to begin my coaching journey.',
    '',
    `Name: ${name.trim()}`,
    `Email: ${email.trim()}`,
  ];

  const trimmedMessage = message?.trim();
  if (trimmedMessage) {
    lines.push('', 'What brought me here:', trimmedMessage);
  }

  lines.push('', '—', 'Sent via Rise With Presence website');

  return lines.join('\n');
}

export function buildWhatsAppUrl(phone, text) {
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
}

export function openWhatsAppEnquiry({ name, email, message }) {
  const text = formatEnquiryMessage({ name, email, message });
  const url = buildWhatsAppUrl(RISE_WITH_PRESENCE_WHATSAPP, text);
  window.open(url, '_blank', 'noopener,noreferrer');
}
